import React from 'react';
import { FormControl, FormLabel, Select, OutlinedInput  } from '../../../../third-party-components/material-ui';

const DemoQuestionDropDownList = ({name, label, value, data, required = false, visible =true, disabled = false,  textField, dataItemKey, onChange, validationMessage}) => {
    if (!visible) {
        return null;
    }
    
    return (
      <div style={{display: visible ? 'block' : 'none'}}>
        <React.Fragment>
            <FormLabel className="demo-error" component="legend">{validationMessage}</FormLabel>
            <FormControl className="demo-control demo-select">
                <FormLabel className="demo-label" component="legend">{label}{required && <span className="label-required">*</span>}</FormLabel>
                <Select
                    disabled={disabled}
                    native
                    name={name}
                    value={value}
                    onChange={onChange}
                    input={<OutlinedInput />}
                    >
                    {data.map((item,index) => (
                        <option key={index} value={item[dataItemKey]}>{item[textField]}</option>
                    ))}
            </Select>
            </FormControl>
        </React.Fragment>
      </div>
    )
}

export default DemoQuestionDropDownList;